function windowHeight() {
  var windowHeight = window.innerHeight;
  return windowHeight;
} 
function headerHeight() {
  const headerHeight = document.querySelector('[data-site-header]').offsetHeight;
  //console.log(headerHeight);
  return headerHeight;
}

console.log('header-height',headerHeight());

document.documentElement.style.setProperty('--window-height', windowHeight() + 'px'); 
document.documentElement.style.setProperty('--header-height', headerHeight() + 'px');


addEventListener('resize', debounce(() => { 
  document.documentElement.style.setProperty('--window-height', windowHeight() + 'px'); 
  document.documentElement.style.setProperty('--header-height', headerHeight() + 'px');
},100));  
            



/************* DRAWERS *****************/

$(document).on('click touch','[data-drawer-target]',function(e){
  e.preventDefault();
  var toggle = $(this)
  var target = toggle.data('drawer-target');
  
  toggle.toggleClass('active');
  $('body').toggleClass('overflow-hidden');
  $('[data-drawer-container="'+target+'"]').toggleClass('active').focus();
});


function openDrawer(target) {
  $('body').toggleClass('overflow-hidden');
  $('[data-drawer-container="'+target+'"]').toggleClass('active');
}

$('[data-drawer-close]').on('click',function() {
   closeDrawers();
});

$(document).keyup(function(e) {
  if (e.key === "Escape" && $('[data-drawer-container]').hasClass('active')) {  
       //console.log(e.key);
     closeDrawers();
    }
});

 

$('html:not([data-drawer-target]').on('click',function(event) { 

  var $target = $(event.target);
  if(!$target.closest('[data-drawer-container]').length && $('[data-drawer-container').hasClass('active')) {
    console.log('close drawers');
    closeDrawers();
  }  else {
  //console.log('do nothing');
  }

});
  
 

function closeDrawers() {
   $('body').removeClass('overflow-hidden');
   $('[data-drawer-target],[data-drawer-container]').removeClass('active');
}

/******* QUERY HELPERS ***********/
// jquery toggle whole attribute
  $.fn.toggleAttr = function(attr, val) {
    var test = $(this).attr(attr);
    if ( test ) { 
      // if attrib exists with ANY value, still remove it
      $(this).removeAttr(attr);
    } else {
      $(this).attr(attr, val);
    }
    return this;
  };

  // jquery toggle just the attribute value
  $.fn.toggleAttrVal = function(attr, val1, val2) {
    var test = $(this).attr(attr);
    if ( test === val1) {
      $(this).attr(attr, val2);
      return this;
    }
    if ( test === val2) {
      $(this).attr(attr, val1);
      return this;
    }
    // default to val1 if neither
    $(this).attr(attr, val1);
    return this;
  };


/************ STICKY HEADER ***************/
if($('.site-header').length){
function fixHeader() {
  var header = $('.site-header');
  var stickyOffset = $('.site-header').offset().top;
  header.addClass('fixed');
$('body').addClass('fixed-header');
  $(window).scroll(debounce(function () {
      checkHeader;
  }, 50));

  function checkHeader() {
      scroll = $(window).scrollTop();
      if (scroll > stickyOffset) {
          header.addClass('scrolling');
      } else {
          header.removeClass('scrolling');
      }
  }
}
$(window).resize(debounce(function () {
  fixHeader();
}, 50));
$(window).on('load', function () {
  fixHeader();
});
}
/***************** TOGGLES *******************/
$('[data-toggle]').on('click',function(e) {
  e.preventDefault();
  var target = $(this).data('target');
  $(this).toggleClass('active');
  $('[data-content="'+target+'"]').slideToggle();
});
 
$('[data-tab-target]').on('click',function(e) {
  e.preventDefault();
  var clickTarget = $(this);
  var target = $(this).data('tab-target');
  var parentDiv = clickTarget.parents('div');
  var parentContentDiv = $('[data-tab-content="'+target+'"]').parents('div');

  console.log(parentContentDiv);
  parentDiv.find('[data-tab-target]').removeClass('active');
  parentContentDiv.find('[data-tab-content]').removeClass('active');

  clickTarget.addClass('active');
  $('[data-tab-content="'+target+'"]').addClass('active');

});

/************ Smooth Scroll to Anchor With OFFSET JQUERY VERSION  ****************/

$('a[href*="#"]:not([href="#"], .no-scroll)').click(function() {
  var offset = - $('header').height();
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
          $('html, body').animate({
              scrollTop: target.offset().top + offset
          }, 500);
          return false;
      }
  }
});